import { render, staticRenderFns } from "./LayoutBasico.vue?vue&type=template&id=07aba27c&scoped=true&"
import script from "./LayoutBasico.vue?vue&type=script&lang=js&"
export * from "./LayoutBasico.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBasico.vue?vue&type=style&index=0&id=07aba27c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aba27c",
  null
  
)

export default component.exports